<template>
  <div class="footer-container row">
    <div class="main" @click="goTo">京ICP备18009005号-6</div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    goTo() {
      window.open('http://beian.miit.gov.cn/');
    }
  }
};
</script>

<style lang="scss" scoped>
.footer-container {
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 28px;
  background-color: #ffffff;
  border-top: 1px solid #f2f3f7;
  font-size: 12px;
  z-index: 1;
  .main {
    color: #747990;
    cursor: pointer;
    &:hover {
      color: #747990;
    }
  }
}
</style>
